module.exports = __webpack_public_path__ + "static/media/20.a0cc8f22.mp3";